import { useEffect } from 'react'

export default function useClearTimeout(id) {
  useEffect(() => {
    return () => {
      clearTimeout(id)
    }
  }, [id])
}
